<div class="staking" id="staking">
  <div class="container">
    <div class="row d-flex align-items-center justify-content-between">
      <!-- ====== staking title/desc and Withdraw button ====== -->

      <div class="col-lg-7 col-12 text-center text-lg-start">
        <h1 class="section-title">{{ 'staking.title' | translate }}</h1>
        <p class="section-desc"
        [innerHTML]="'staking.desc' | translate: { rewardRate: stakeData.rewardPerRound, url: home }"></p>
      </div>

      <div class="col-lg-5 col-12 d-flex justify-content-center justify-content-lg-end">
        <button class="btn btn-primary w-auto" (click)="openWithdrawModal(withdraw)">{{ 'staking.withdraw_title' |
        translate }}</button>
      </div>

      <div class="col-12 mt-5">
        <div class="box-wrap">

          <!-- ====== Current Reward card ====== -->

          <div class="box">
            <div>
              <span class="title">{{ 'staking.card_4_title' | translate }}</span>
              <h2 class="value">
                {{ stakeData.rewardPerRound }}
                <sup class="coin">{{ 'staking.card_block' | translate }}</sup>
              </h2>
            </div>
          </div>

          <!-- ====== Total Reward card====== -->

          <div class="box">
            <div>
              <span class="title">{{ 'staking.card_5_title' | translate }}</span>
              <div class="d-flex align-items-center justify-content-between">
                <h2 class="value">
                  {{ userReward }}
                  <span class="coin">{{ 'staking.card_coin' | translate }}</span>
                </h2>
                <button class="btn btn-primary w-auto" (click)="harvestRewards()">{{ 'staking.rewards_btn' | translate
                }}</button>
              </div>
            </div>
          </div>


          <!-- ====== Estimated reward  card====== -->

          <div class="box">
            <div>
              <span class="title">{{ 'staking.card_3_title' | translate }}</span>
              <div class="d-flex align-items-center justify-content-between">
                <h2 class="value">
                  {{ stakeData.apy }}%<sup class="coin ps-2 mt-2">{{ 'staking.stake_pa' | translate }}</sup>
                </h2>

                <ul class="p-0 m-0">
                  <li><img src="/assets/images/svg-icons/arrow-right.svg" height="8px" class="me-1" alt="Right Arrow"
                  loading="eager" />{{ 'staking.card_3_para_1' | translate }}</li>
                  <li><img src="/assets/images/svg-icons/arrow-right.svg" height="8px" class="me-1" alt="Right Arrow"
                  loading="eager" />{{ 'staking.card_3_para_2' | translate }}</li>
                  <li><img src="/assets/images/svg-icons/arrow-right.svg" height="8px" class="me-1" alt="Right Arrow"
                  loading="eager" />{{ 'staking.card_3_para_3' | translate }}</li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- ====== chart wrapper ====== -->

    <div class="row mt-3 mt-lg-5 align-items-start justify-content-between">
      <div class="col-12 col-lg-9 mb-3">
        <div class="chart-wrapper">
          <div class="px-3">
            <h2 class="mt-4 text-center font-18">{{ 'staking.total_rewards' | translate }}</h2>
          </div>
          @if (pageLoaded) {
            <div class="w-100 graph-parent" #graphCont>
              <ngx-charts-bar-vertical [view]="view" [scheme]="colorScheme" [results]="rewards" [gradient]="gradient"
                [xAxis]="showXAxis" [yAxis]="showYAxis" [legendTitle]="legendTitle" [legend]="showLegend"
                [yScaleMin]="minYAxis" [yScaleMax]="maxYAxis" [showXAxisLabel]="showXAxisLabel"
                [showYAxisLabel]="showYAxisLabel" [showGridLines]="showGridLines" [showDataLabel]="showDataLabel"
                [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel" [yAxisTickFormatting]="yAxisTickFormattingFn">
              </ngx-charts-bar-vertical>
            </div>
          }
        </div>

        <div class="mt-2">
          <p class="font-14 text-white mb-0">
            {{ 'staking.staking_powered_by' | translate }}
            <a href="https://web3paymentsolutions.io/" target="_blank" (click)="trackPartnerClick()">
              <img src="/assets/images/svg-icons/W3P_White.svg" alt="Web3Payments" class="poweredByIcon" height="18"
                loading="eager" />
              </a>
            </p>
          </div>
        </div>

        <div class="col-12 col-lg-3">

          <!-- ====== % OF POOL card ====== -->

          <div class="box">
            <div class="w-100">
              <div class="d-flex align-items-center justify-content-between">
                <span class="title">{{ 'staking.card_2_title' | translate }}</span>
                <img src="/assets/images/svg-icons/info-icon.svg" class="img-fluid cursor-pointer" alt="Info Icon"
                  loading="eager" (click)="poolInfo()" />
                </div>
                <h2 class="value">{{ poolPercent }}%</h2>
                <div>
                  <span class="title">{{ 'staking.total_staked' | translate }}</span>
                  <h2 class="value">
                    {{ totalStaked }}
                    <span class="coin">{{ 'staking.card_coin' | translate }}</span>
                  </h2>
                </div>
                <!-- <button class="btn btn-primary w-100 mt-3" (click)="openWithdrawModal(withdraw)">{{ 'staking.withdraw_title' | translate }}</button> -->
              </div>
            </div>

            <!-- ====== Buy and stake card ====== -->
            <div class="box mt-3">
              <div>
                <span class="title">{{ 'staking.card_1_title' | translate }}</span>
                <h2 class="value">{{ userStaked }}<span class="coin">{{ 'staking.card_coin' | translate }}</span></h2>
              </div>

              <div>
                <span class="title">{{ 'staking.your_stakeable' | translate }} </span>
                <h2 class="value">{{(userBal > 0 && isClaimActive) ? userBalString : ethClaimable}}
                  <span class="coin">{{ 'staking.card_coin' | translate }}</span>
                </h2>
              </div>

              <!-- == Claim And Stake == -->
              @if (ethTokens && ethTokens > 0) {
                <a class="btn btn-primary w-100 mt-3" title="staking"
                (click)="claimAndStake()">{{ 'staking.claim_stake' | translate }}</a>
              }

              <!-- == Buy And Stake == -->
              @if (ethTokens == 0 && !isClaimActive) {
                <a class="btn btn-primary w-100 mt-3" (click)="buyClaimStake(buy_stake)"
                >{{ 'staking.buy_stake' | translate }}</a>
              }

              <!-- == Claim And Stake wallet token == -->
              @if (userBal > 0 && isClaimActive) {
                <a class="btn btn-primary w-100 mt-3" (click)="openModal(stake)">{{
                'staking.buy_stake' | translate }}</a>
              }


            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- ====== token withdraw modal ====== -->

    <ng-template #withdraw>
      <div class="modal-header d-flex align-items-center justify-content-center position-relative">
        <h4 class="modal-title pull-left">{{ 'staking.withdraw_title' | translate }}</h4>
      </div>
      <div class="modal-body">
        <div class="text-center">
          <span>{{ 'staking.card_1_title' | translate }}</span>
          <h2 class="font-25">
            {{ userStaked }}
            <span class="font-14">{{ 'staking.card_coin' | translate }}</span>
          </h2>
          @if (stakeData.userStaked > 0) {
            <div class="d-inline-block text-white ms-2 font-14">
              {{ 'staking.withdraw_text' | translate: { unstakeDate: (unstakeDate | date: 'dd/MM/yyyy hh:mm:aa') } }}
            </div>
          }
        </div>

        <div class="d-flex align-items-center gap-2 mt-3">
          <button class="btn btn-outline-primary w-100" (click)="closeModal()">{{ 'misc.cancel' | translate }}</button>
          <button class="btn btn-primary w-100" (click)="withdrawStake()" [disabled]="!canUnstake">{{ 'staking.withdraw' |
          translate }}</button>
        </div>
      </div>
    </ng-template>

    <!-- ====== stake modal ====== -->

    <ng-template #stake>
      <div class="modal-header d-flex align-items-center justify-content-center position-relative">
        <h4 class="modal-title">{{ 'widget.stake_token' | translate }}</h4>
      </div>
      <div class="modal-body">
        <div class="text-center mb-3">
          <span class="staking-title font-14 text-uppercase mb-1 d-inline-block">{{ 'widget.user_bal' | translate }}</span>
          <h2 class="font-25 mt-2 text-secondary d-flex align-items-start fw-bold justify-content-center">{{ userBalString
            }}
            <span class="d-inline-block text-white ms-2 font-12 fw-bold">{{ 'staking.card_coin' | translate }}</span>
          </h2>
        </div>

        <div class="form-group">
          <div class="d-flex align-items-center justify-content-between">
            <label class="font-12">{{ 'widget.stake_amount' | translate }}</label>
            <a class="font-12 text-decoration-underline cursor-pointer text-secondary" (click)="max()">{{ 'widget.max' |
            translate }}</a>
          </div>
          <input type="text" class="form-control text-black" placeholder="0" [(ngModel)]="stakeAmount" />
          <p class="font-13">{{ 'widget.enterAmount' | translate }}</p>
        </div>

        <div class="d-flex align-items-center">
          <button class="btn btn-secondary font-16 text-white ms-3 w-100" (click)="closeModal()">{{ 'misc.cancel' |
          translate }}</button>
          <button class="btn btn-secondary font-16 text-white ms-3 w-100"
            [disabled]="!stakeAmount || (stakeAmount > userBal) || userBal === 0" (click)="stakeToken(successfull)">
            {{"widget.stake_now" | translate}}
          </button>
        </div>
      </div>
    </ng-template>

    <!-- ====== successful modal ====== -->
    <ng-template #successfull>
      <div class="modal-body d-flex align-items-center flex-column justify-content-center">
        <div class="text-center w-100 mb-3">
          <!-- ====== show loader ====== -->
          @if (status === SwapStatus.in_progess) {
            <div class="body-section text-center">
              <img src="/assets/images/svg-icons/logo.svg" alt="loading" class="statusIcon loading" loading="lazy" />
              <div class="fw-normal fw-bold font-16 px-2 my-3 text-uppercase text-white text-center">{{
              'widget.transaction_in_progress' | translate }}</div>
              <p class="fs-7 mb-0 text-white">{{ 'staking.stake_transction_info' | translate: { stakeAmount } }}</p>
            </div>
          }

          <!-- ====== show confirm ====== -->

          @if (status === SwapStatus.confirm_pending) {
            <div class="body-section text-center">
              <img src="/assets/images/svg-icons/logo.svg" alt="loading" class="statusIcon loading" loading="lazy" />
              <div class="fw-semibold fs-6 my-3 text-uppercase text-black text-center">{{ 'misc.confirm' | translate }}</div>
              <p class="fs-7 mb-0 text-white">{{ 'staking.stake_waiting_confirm' | translate: { cryptoName } }}</p>
            </div>
          }

          <!-- ====== show pending ====== -->

          @if (status === SwapStatus.approval_pending) {
            <div class="body-section text-center">
              <img src="/assets/images/svg-icons/logo.svg" alt="loading" class="statusIcon loading" loading="lazy" />
              <div class="fw-semibold fs-6 my-3 text-uppercase text-black text-center">{{ 'widget.authorise' | translate }}
              </div>
              <p class="fs-7 mb-0 text-white">{{ 'staking.stake_waiting_approve' | translate }}</p>
            </div>
          }

          <!-- ====== show success/completed ====== -->

          @if (status === SwapStatus.complete) {
            <div class="body-section text-center">
              <img src="/assets/images/popup-icons/success.svg" alt="complete" class="statusIcon" loading="lazy" />
              <div class="fw-semibold fs-6 my-3 text-uppercase text-success text-center">{{ 'stake_transaction_success' |
              translate }}</div>
              <p class="fs-7 mb-3 mb-lg-4 text-black">{{ 'staking.stake_transction_info' | translate: { stakeAmount } }}</p>
              <div class="d-flex align-items-center justify-content-center gap-3">
                <button class="btn btn-outline-tertiary fs-7 w-100" (click)="viewUrl()">{{ 'widget.view_transaction' |
                translate }}</button>
                <button class="btn btn-outline-secondary fs-7 w-100" (click)="closeModal()">{{ 'misc.done' | translate
                }}</button>
              </div>
            </div>
          }

          <!-- ====== show failed ====== -->

          @if (status === SwapStatus.failed) {
            <div class="body-section text-center">
              <img src="/assets/images/popup-icons/warning.svg" alt="failed" class="statusIcon" loading="lazy" />
              <div class="fw-semibold fs-6 my-3 text-uppercase text-danger text-center">{{ 'staking.stake_transaction_failed'
              | translate }}</div>
              <p class="fs-7 mb-3 mb-lg-4 text-warning">{{ 'staking.stake_view_transaction_info' | translate }}</p>
              <div class="d-flex align-items-center justify-content-center gap-3">
                <button class="btn btn-outline-tertiary fs-7 w-100" (click)="viewUrl()">{{ 'widget.view_transaction' |
                translate }}</button>
                <button class="btn btn-outline-secondary fs-7 w-100" (click)="closeModal()">{{ 'misc.done' | translate
                }}</button>
              </div>
            </div>
          }

          <!-- ====== show rejected ====== -->

          @if (status === SwapStatus.rejected) {
            <div class="body-section text-center">
              <img src="/assets/images/popup-icons/warning.svg" alt="failed" class="statusIcon" loading="lazy" />
              <div class="fw-semibold fs-6 text-uppercase text-warning my-3 text-center">{{
              'staking.stake_transaction_rejected' | translate }}</div>
              <div class="d-flex align-items-center justify-content-center gap-3 mt-4">
                <button class="btn btn-outline-secondary fs-7 w-100" (click)="closeModal()">{{ 'misc.done' | translate
                }}</button>
              </div>
            </div>
          }
        </div>
      </div>
    </ng-template>

    <!-- ====== Buy and stake modal ====== -->
    <ng-template #buy_stake>
      <div class="modal-header d-flex align-items-center justify-content-between">
        <div></div>
        <h4 class="modal-title">{{ 'staking.buy_stake' | translate }}</h4>
        <svg-icon src="/assets/images/svg-icons/close-white.svg" [svgStyle]="{ 'width.px': 12, 'height.px': 12 }"
        class="cursor-pointer" (click)="closeModal()"></svg-icon>
      </div>
      <div class="modal-body">
        <!-- <app-swap [isNative]="true" [isWert]="isWert" [isModal]="true" (messageEvent)="messageEvent($event)"></app-swap> -->
        <app-swap [isNative]="true" [isWert]="isWert" [isModal]="true" (messageEvent)="messageEvent($event)"></app-swap>
      </div>
    </ng-template>